import { axiosInstnace as axios } from './util';

class http {

  get= async(url)=> {
    let response= await axios.get(url);
    return response;
  }

  post= async(url, data)=> {
    let response= await axios.post(url, data);
    return response;
  }

  put = async(url, data)=> {
    let response = await axios.put(url, data);
    return response;
  }

}

export default new http();


// WEBPACK FOOTER //
// ./web/util/http.js